import { gql } from 'apollo-boost';

export const EXTRACT_URL_TRANSCRIPT = gql`
    mutation($data: ExtractUrlTranscriptInput!) {
        extractUrlTranscript(data: $data) {
            __typename
            ... on Message {
                id
                body
                transcript {
                    text
                    source
                    status
                    sourceUrl
                    urlMetaIndex
                    provider
                    model
                    createdAt
                    updatedAt
                    detectedLanguages
                    language
                    segments {
                        start
                        end
                        text
                    }
                }
                transcriptionSegments {
                    start
                    end
                    text
                }
                metadata {
                    audioProcessing {
                        status
                        outputFormat
                        error
                        startedAt
                        completedAt
                    }
                }
            }
            ... on ExtractUrlTranscriptError {
                message
                code
            }
        }
    }
`;
